module.exports = __webpack_public_path__ + "img/align-left.9821cba1.svg";